var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Button as ChakraButton, } from "@chakra-ui/react";
import { Size, Variant, Spacing } from "../../core/constants";
import { pick } from "../../core/utils";
import { renderIcon } from "../Icon";
export const ButtonSize = pick(Size, ["xs", "sm", "md", "lg", "xl"]);
export const ButtonVariant = pick(Variant, [
    "outline",
    "unstyled",
    "ghost",
    "link",
    "solid",
]);
/**
 * The `Button` component represents a clickable button,
 *  used to submit forms or anywhere in a document for accessible, standard button functionality.
 */
const Button = forwardRef((_a, ref) => {
    var { className, children, size = Size.lg, type = "button", colorScheme, variantColor, iconSpacing = Spacing[2], leftIcon, rightIcon } = _a, rest = __rest(_a, ["className", "children", "size", "type", "colorScheme", "variantColor", "iconSpacing", "leftIcon", "rightIcon"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(ChakraButton, Object.assign({}, rest, { ref: ref, size: size, className: className, type: type, iconSpacing: iconSpacing, colorScheme: scheme, leftIcon: renderIcon(leftIcon, size), rightIcon: renderIcon(rightIcon, size) }), children));
});
Button.displayName = "Button";
export default Button;
//# sourceMappingURL=Button.js.map